import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

/**
 * Renders children only if can(allow) is true (permissions and/or role names, same rules as AuthContext.can).
 * On failure, redirects to /access-denied with state.from set to the attempted path (unless redirectTo overrides).
 */
const RequireCan = ({ allow, redirectTo = '/access-denied', children }) => {
  const { can, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="admin-content">
        <div style={{ display: 'flex', justifyContent: 'center', padding: 60 }}>
          <div className="spinner" style={{ width: 32, height: 32 }} />
        </div>
      </div>
    );
  }
  if (!can(allow)) {
    if (redirectTo === '/access-denied') {
      return <Navigate to="/access-denied" state={{ from: location.pathname }} replace />;
    }
    return <Navigate to={redirectTo} replace />;
  }
  return children;
};

export default RequireCan;
